export default "__VITE_ASSET__DMl0Xq0R__"